import { reportsTopProductsRetrieveOptions } from '@crm/api'
import { getColor } from '@crm/components/Charts/utils'
import { SkeletonWrapper } from '@shared/components'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { useQuery } from '@tanstack/react-query'
import { Button, Card, Dropdown } from 'antd'
import { More } from 'iconsax-react'

import { ReportsPieChart } from './ReportsPieChart'
import { useReportExport } from '../hooks'

export const TopProductsChart = () => {
  const { t } = useLocales()
  const { params } = useQueryUpdate()

  const { onExport, dropdownItems } = useReportExport('top-products', params)

  const { data, isLoading } = useQuery({
    ...reportsTopProductsRetrieveOptions({
      query: { date_from: params.date_from, date_to: params.date_to, ...params }
    }),
    enabled: !!params.date_from && !!params.date_to
  })

  const chartData =
    data?.products?.map((item, index) => ({
      name: item.product_name,
      opportunity_count: item.opportunity_count,
      total_value: item.total_value,
      currency: item.currency,
      total: item.opportunity_count,
      color: getColor(index)
    })) || []

  return (
    <Card
      title={t('reports.top_products', { count: 10 })}
      loading={isLoading}
      extra={
        <Dropdown
          menu={{ items: dropdownItems, onClick: onExport }}
          trigger={['click']}
        >
          <Button icon={<More size={18} />} />
        </Dropdown>
      }
    >
      <SkeletonWrapper loading={isLoading} paragraph={{ rows: 10 }}>
        <ReportsPieChart
          data={chartData}
          chartText={t('reports.products')}
          textColumn={t('billing.product')}
          chartHeight={300}
        />
      </SkeletonWrapper>
    </Card>
  )
}
